import styled from 'styled-components';
import { getThemeColor } from 'utils/styled';
import { MENU_BORDER_RADIUS_PX } from '../constants';

export const Root = styled.div`
  background-color: ${getThemeColor('l2')};
  border-radius: ${MENU_BORDER_RADIUS_PX}px;
  box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.15);
  color: ${getThemeColor('d1')};
  overflow: hidden;
  border: solid 2px ${getThemeColor('l4')};
`;
